define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Model.extend({
        url: "/rest_account/validate_additional_account_tc_form",

        validation: {
            check_bonus: {
                acceptance: true
            },
            check_tc: {
                acceptance: true
            },
            check_compliance_tc: {
                acceptance: true
            },
            tc_signature_data: {
                required: true
            },
        },

        labels:{
            check_bonus: "The Bonus",
            check_tc: "The Terms and Conditions",
            check_compliance_tc: "The Terms and Conditions",
            tc_signature_data: "Signature",
        },
    });
});
